(function () {
    var toggle = document.querySelector('.bh-billing-toggle');
    if (!toggle) return;
    var periods = document.querySelectorAll('[data-billing-period]');
    function choose(value) {
        toggle.querySelectorAll('button').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.billing === value)); });
        periods.forEach(function (period) { period.hidden = period.dataset.billingPeriod !== value; });
    }
    toggle.hidden = false;
    toggle.querySelectorAll('button').forEach(function (button) { button.addEventListener('click', function () { choose(button.dataset.billing); }); });
    choose('monthly');
})();
